import { useMutation } from '@tanstack/vue-query'
import type { IBlockContactFormRequest } from '@/features/block-contact-form/types/IBlockContactFormRequest.ts'
import { sendBlockContactForm } from '@/features/block-contact-form/api/endpoints/blockContactForm.ts'

export default function useSendBlockContactForm() {
  const { mutate, isPending, isSuccess } = useMutation({
    mutationFn: (request: IBlockContactFormRequest) => sendBlockContactForm(request),
    retry: false,
  })

  return {
    sendBlockContactForm: mutate,
    isSendingBlockContactForm: isPending,
    isSuccessSendBlockContactForm: isSuccess,
  }
}
